import { api } from '@/api/client'

export interface SearchResult<T> {
  data: T[]
  meta: { total: number; current_page: number; last_page: number }
}

export interface GlobalSearchItem {
  id: number
  label: string
  meta?: string | null
  path: string
}

export interface GlobalSearchGroups {
  categories: GlobalSearchItem[]
  products: GlobalSearchItem[]
  orders: GlobalSearchItem[]
  customers: GlobalSearchItem[]
  adverts: GlobalSearchItem[]
  blogs: GlobalSearchItem[]
}

export async function searchAdminGlobal(q: string): Promise<GlobalSearchGroups> {
  const { data } = await api.get<{ success: boolean; data: GlobalSearchGroups }>(
    '/admin/search/global',
    { params: { q: q.trim() } },
  )
  return data.data
}

export async function searchAdminProducts(params?: {
  q?: string
  page?: number
  limit?: number
}): Promise<SearchResult<unknown>> {
  const { data } = await api.get<{ success: boolean; data: unknown[]; meta: { total: number; current_page: number; last_page: number } }>(
    '/admin/search/products',
    {
      params: {
        q: params?.q?.trim() || '',
        page: params?.page ?? 1,
        limit: params?.limit ?? 20,
      },
    },
  )
  return { data: data.data, meta: data.meta }
}

export async function searchAdminAdverts(params?: {
  q?: string
  page?: number
  limit?: number
}): Promise<SearchResult<unknown>> {
  const { data } = await api.get<{ success: boolean; data: unknown[]; meta: { total: number; current_page: number; last_page: number } }>(
    '/admin/search/adverts',
    {
      params: {
        q: params?.q?.trim() || '',
        page: params?.page ?? 1,
        limit: params?.limit ?? 20,
      },
    },
  )
  return { data: data.data, meta: data.meta }
}

export async function searchAdminBlogs(params?: {
  q?: string
  page?: number
  limit?: number
}): Promise<SearchResult<unknown>> {
  const { data } = await api.get<{ success: boolean; data: unknown[]; meta: { total: number; current_page: number; last_page: number } }>(
    '/admin/search/blogs',
    {
      params: {
        q: params?.q?.trim() || '',
        page: params?.page ?? 1,
        limit: params?.limit ?? 20,
      },
    },
  )
  return { data: data.data, meta: data.meta }
}
